import { render, staticRenderFns } from "./basic-picker.mpx?vue&type=template&id=5be6d4c2&isComponent&outputPath=components%2Fbasic-picker7cf32a11%2Findex"
import script from "./basic-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbasic-picker7cf32a11%2Findex"
export * from "./basic-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbasic-picker7cf32a11%2Findex"
import style0 from "./basic-picker.mpx?vue&type=style&index=0&id=5be6d4c2&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_7cf32a11%22%7D&isComponent&outputPath=components%2Fbasic-picker7cf32a11%2Findex"
import style1 from "./basic-picker.mpx?vue&type=style&index=1&id=5be6d4c2&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_7cf32a11%22%7D&isComponent&outputPath=components%2Fbasic-picker7cf32a11%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports